import "./i18n";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./components/theme/ThemeProvider";
import { AuthProvider } from "./components/auth/AuthProvider";
import AdminRoute from "./components/auth/AdminRoute";
import Layout from "./components/layout/Layout";
import { useEffect, useState } from "react";
import i18n from "./i18n";

import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Auth from "./pages/Auth";
import BlogPage from "./pages/BlogPage";
import BlogPost from "./pages/BlogPost";
import CoursesPage from "./pages/CoursesPage";
import CourseDetails from "./pages/CourseDetails";
import CourseLesson from "./pages/CourseLesson";
import Dashboard from "./pages/Dashboard";
import AdminCoursesPage from "./pages/AdminCoursesPage";
import AuthWithPassword from "./pages/AuthWithPassword";

const queryClient = new QueryClient();

const App = () => {

  // BrowserRouter is needed for routing, so we use it inside the component
  const AppWithRouter = () => {
    return (
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Index lang="en" />} />
          <Route path="/blog" element={<BlogPage lang="en" />} />
          <Route path="/blog/:slug" element={<BlogPost lang="en" />} />
          <Route path="/courses" element={<CoursesPage lang="en" />} />
          <Route path="/courses/:slug" element={<CourseDetails lang="en" />} />
          <Route path="/courses/:courseSlug/:moduleSlug/:lessonSlug" element={<CourseLesson lang="en" />} />
          <Route path="/auth" element={<Auth lang="en" />} />
          <Route path="/authwithpassword" element={<AuthWithPassword lang="en" />} />
          <Route path="/dashboard" element={<Dashboard lang="en" />} />
          <Route path="/fr" element={<Index lang="fr" />} />
          <Route path="/fr/blog" element={<BlogPage lang="fr" />} />
          <Route path="/fr/blog/:slug" element={<BlogPost lang="fr" />} />
          <Route path="/fr/courses" element={<CoursesPage lang="fr" />} />
          <Route path="/fr/courses/:slug" element={<CourseDetails lang="fr" />} />
          <Route path="/fr/courses/:courseSlug/:moduleSlug/:lessonSlug" element={<CourseLesson lang="fr" />} />
          <Route path="/fr/auth" element={<Auth lang="fr" />} />
          <Route path="/fr/authwithpassword" element={<AuthWithPassword lang="fr" />} />
          <Route path="/fr/dashboard" element={<Dashboard lang="fr" />} />

          {/* Admin Route */}
          <Route element={<AdminRoute />}>
            <Route path="/admin/courses" element={<AdminCoursesPage />} />
            {/* Add other admin routes here later */}
          </Route>

          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    );
  };

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <TooltipProvider>
            <Toaster />
            <Sonner />
            <BrowserRouter>
              <AppWithRouter />
            </BrowserRouter>
          </TooltipProvider>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;
